// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"d1ae55bd","675":"0628878f","747":"feb5b61c","884":"0a014e33"}[chunkId] + ".chunk.css";
};